import { inject } from 'vue'
import { t } from '@/libs/i18n'

export function useSaveStatus() {
  const statusMessage = inject('saveStatusMessage')
  const isSaving = inject('isSaving')
  const errors = inject('errors')
  const isDraft = inject('isDraft', false)

  const setErrors = (newErrors) => {
    errors.value = newErrors
  }

  const resetErrors = () => {
    setErrors({})
    setStatus(null)
  }

  const setStatus = (message) => {
    statusMessage.value = message
  }

  const setIsSaving = (newState) => {
    isSaving.value = newState
    // On start: the back click that blurs an edit lands before the save finishes.
    if (newState) window.dispatchEvent(new CustomEvent('slides-editor:saving'))
  }

  const setStatusToLastSaved = () => {
    const time = isDraft
      ? new Date().toLocaleTimeString('en', { hour: 'numeric', minute: '2-digit' }).replace(/\s/g, '').toLowerCase()
      : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    statusMessage.value = t(`slides_editor.status_messages.${isDraft ? 'draft_saved' : 'last_saved'}`, { time })
  }

  return {
    statusMessage,
    setStatus,
    setStatusToLastSaved,
    setIsSaving,
    setErrors,
    resetErrors
  }
}
